import { render, staticRenderFns } from "./PerkinIndividu.vue?vue&type=template&id=a8fdcef8&scoped=true&"
import script from "./PerkinIndividu.vue?vue&type=script&lang=js&"
export * from "./PerkinIndividu.vue?vue&type=script&lang=js&"
import style0 from "./PerkinIndividu.vue?vue&type=style&index=0&id=a8fdcef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fdcef8",
  null
  
)

export default component.exports